import {
  provideHttpClient,
  HTTP_INTERCEPTORS,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http'
import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core'
import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app'
import { getAuth, provideAuth } from '@angular/fire/auth'
import {
  provideRemoteConfig,
  getRemoteConfig,
} from '@angular/fire/remote-config'
import { provideStorage, getStorage } from '@angular/fire/storage'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideRouter, Router, withRouterConfig } from '@angular/router'

import * as Sentry from '@sentry/angular'
import { getStorage as getFirebaseStorage } from 'firebase/storage'

import { routerConfig, routes } from './app.routes'
import { graphqlProvider } from './graphql.provider'
import { environment } from '../environments/environment'
import { NoopInterceptor } from './interceptors/http.interceptor'
import { RECORDING_CHUNKS_STORAGE } from './services/meeting-recording.service'
import {
  FirebaseTokenProvider,
  DefaultFirebaseTokenProvider,
} from './services/roleplay/active-session-count.service'

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes, withRouterConfig(routerConfig)),
    provideAnimationsAsync(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideRemoteConfig(() => getRemoteConfig()),
    provideAuth(() => {
      const auth = getAuth()
      return auth
    }),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoopInterceptor,
      multi: true,
    },
    provideStorage(() => getStorage()),
    {
      provide: RECORDING_CHUNKS_STORAGE,
      useFactory: () =>
        getFirebaseStorage(
          getApp(),
          `gs://${environment.recordingChunksBucket}`,
        ),
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService)
    }),
    graphqlProvider,
    { provide: FirebaseTokenProvider, useClass: DefaultFirebaseTokenProvider },
  ],
}
